export default __webpack_public_path__ + "static/application_banner-263e5c814054565734a57725d99f44ff.png";